module.exports = __webpack_public_path__ + "media/images/bain nordique-033abb143fe6001ef367cf1dec1b8ff1.svg";